<template>
  <div v-if="this.$route.name !== 'statisticsTemplates'" class="subtitle-1">
    <div v-if="type === 'text'">
      <div
        v-if="hint.hintActive"
        class="justify-space-between layout content-bg--4"
      >
        <div
          v-html="hint.hint"
          class="text--primary px-4 py-4 flex xs12 lg9"
        ></div>
        <v-btn class="flex-none ma-0" @click="toggleHint" icon>
          <icon-close></icon-close>
        </v-btn>
      </div>
      <v-layout
        v-else-if="btnMore"
        class="justify-end link"
        @click="toggleHint"
      >
        Подробнее
        <icon-help class="ml-2"></icon-help>
      </v-layout>
    </div>
    <div v-if="type === 'tooltip'">
      <v-tooltip max-width="320" right>
        <template slot="activator">
          <slot name="activatorHint"></slot>
        </template>
        <div v-html="hint.hint" class="subtitle-2"></div>
      </v-tooltip>
    </div>
    <div v-if="type === 'popover'">
      <v-menu
        :open-on-hover="hint.hintActive"
        :max-width="360"
        offset-x
        offset-y
        top
        left
        z-index="1"
      >
        <template slot="activator">
          <slot name="activatorHint"></slot>
        </template>
        <div v-if="hint.hintActive" class="content-bg--2 subtitle-1">
          <div v-html="hint.hint" class="text--primary px-4 py-4"></div>
          <div class="layout justify-end pb-3 pr-3 link" @click="toggleHint">
            Больше не показывать
          </div>
        </div>
      </v-menu>
    </div>
  </div>
</template>

<script>
import IconClose from "../icon/IconClose.vue";
import IconHelp from "../icon/IconHelp.vue";

export default {
  name: "HintWidget",

  components: { IconClose, IconHelp },

  props: {
    // имя модуля страницы для подсказки
    hintName: {
      type: String,
      required: true
    },
    // тип подсказки
    type: {
      type: String,
      required: true
    },
    // для отображения кнопки "Подробнее", если подсказка свернута
    btnMore: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),

  mounted() {},

  computed: {
    // объект подсказки из store
    hint() {
      return this.$store.getters.getHint(this.hintName);
    }
  },

  methods: {
    /**
     * Закрытие подсказки
     */
    toggleHint() {
      this.$store.dispatch("toggleHint", this.hintName);
    }
  }
};
</script>
